import script from "./ExhibitionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitionsView.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitionsView.vue?vue&type=style&index=0&id=a1495b30&lang=scss"

const __exports__ = script;

export default __exports__